export default {
    title: '星星抽奖',
    labels: {
        inventory: '已有头像',
        machine: '星星抽奖机',
    },
    messages: {
        insufficientStars: '星星不够了。 😢',
        ctaText: '点击我放入收藏箱吧！',
    },
};
